import GrnMasterList from '../../slices/grn/grn_master/GrnMasterList'
import GrnMasterDetails from '../../slices/grn/grn_master/GrnMasterDetails'

const grnReducer = {
    grnMasterList: GrnMasterList,
    grnMasterDetails: GrnMasterDetails,
};

export default grnReducer;
